import { convertEnumToList } from '@travelity/utils/converters';
import { VehicleType } from '@travelity/api/generated';
import { VehicleGroup } from './create-asser-modal.types';

export const assetTypeOptions = convertEnumToList<VehicleType>(VehicleType).map(
    ({ value, label }) => ({
        value,
        label: label.replace('_', ' '),
    })
);

export const vehicleGroupOptions = Object.entries(VehicleGroup).map(
    ([, value]) => {
        return {
            label: value,
            value,
        };
    }
);
